/* eslint-disable @typescript-eslint/no-unused-vars */
import { configureStore } from '@reduxjs/toolkit'
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer } from 'redux-persist'
import persistStore from 'redux-persist/es/persistStore'
import storage from 'redux-persist/lib/storage'
import { rootReducer } from './reducers'

const persistConfig = {
  key: 'slides',
  version: 1,
  storage,
  blacklist: ['searchTextPdf', 'pdfStore']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          'pdf/setPdfInfo',
          'pdf/setJumpPagePdf',
          'pdf/setJumpToNextPage',
          'pdf/setJumpPreviousPage',
          'search_pdf/setKeyWord',
          'search_pdf/setMatchPosition',
          'search_pdf/setPageMatchSearch',
          'search_pdf/setRenderStatus',
          'pdf/setCurrentPageRedux'
        ],
        ignoredPaths: ['pdfStore.pdfInfo.doc', 'pdfStore.jumpPagePdf', 'pdfStore.jumpToNextPage', 'pdfStore.jumpToPreviousPage', 'searchTextPdf.renderStatus', 'searchTextPdf.keyword.0.regExp']
      }
    })
})
export const persistor = persistStore(store)
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
